import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import { products } from '@/mixins/products';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import { defaultProduct } from '@editor/page/top-control-bar/dynamic-data/placeholders';
import DropletOptions from '../_bubble-options';
import ProductFeatureOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('product-feature', {
  template: require('./template.html'),
  name: 'product-feature',
  mixins: [cssGenerator, products],
  computed: {
    ...mapGetters([
      'currentPage',
      'currentSite',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    storeData() {
      return this.currentSite.dynamic && this.currentSite.dynamic.products;
    },
    allImages() {
      return [{
        _id: 'main-image',
        altText: this.product.name,
        src: this.product.image }].concat(this.product.extraImages);
    },
    product() {
      const enabled = this.storeData;
      const products = enabled ? (enabled.published || []) : [];
      const ref = this.droplet.product;
      const product = ref && enabled ? _.find(products, p => p._id === ref) : false;
      return product || defaultProduct();
    },
    currencyType() {
      const enabled = this.storeData;
      const symbols = {
        USD: '&#36;',
        CAD: '&#36;',
        EUR: '&#128;',
      };
      const type = enabled && enabled.currency ? enabled.currency : 'USD';
      return {
        type: type.toLowerCase(),
        symbol: symbols[type],
      };
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzProduct-feature' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        perspective: null,
        btnPaddingTop: null,
        btnPaddingBottom: null,
        btnPaddingLeft: null,
        btnPaddingRight: null,
        btnWidth: null,
        btnBorderWidthRight: null,
        btnBorderWidthLeft: null,
        btnBorderWidthTop: null,
        btnBorderWidthBottom: null,
        btnRadiusTopRight: null,
        btnRadiusTopLeft: null,
        btnRadiusBottomRight: null,
        btnRadiusBottomLeft: null,
        btnSize: null,
        priceLetterSpacing: null,
        selectLetterSpacing: null,
        selectLabelSpacing: null,
        selectLabelSize: null,
        selectLabelLine: null,
        countLetterSpacing: null,
        btnLetterSpacing: null,
        'box-shadow': null,
        'border-width': null,
        'line-height': null,
        'font-size': null,
        'letter-spacing': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      showRevealClass: false,
    };
  },
  props: ['droplet', 'items', 'index'],
  components: {
    DropletOptions,
    ProductFeatureOptions,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzProduct-feature',
        });
      }
    },
    product() {
      setTimeout(() => {
        this.destroyPlugin();
        this.initPlugin();
      }, 500);
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    this.initPlugin();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
    destroyPlugin() {
      const $droplet = $(this.$refs.productFeature);
      $droplet.drzProductFeature.destroy($droplet);
    },
    initPlugin() {
      const $droplet = $(this.$refs.productFeature);
      $droplet.drzProductFeature({
        overrides: {
          quantity: {
            max: this.product.maxPurchaseQuantity,
            step: this.product.countStep,
          },
        },
      });
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/product-feature/index.js